import React, { useContext, useState } from 'react';
import {
	Col,
	Button,
	Accordion,
	Card,
	useAccordionButton,
	AccordionContext,
} from 'react-bootstrap';

import { Diagram3Fill } from 'react-bootstrap-icons';

import TreeView from '../../../components/TreeView';
import { renderAncestorTab } from '../../../viewer/GLIFOSMetadataViewer';
import { Plus } from 'react-bootstrap-icons';
import { Dash } from 'react-bootstrap-icons';
import { DRUPAL_URL, ISADG_METADATA } from '../../../utilities/globals';
function CustomToggle({ children, eventKey }) {
	const { activeEventKey } = useContext(AccordionContext);
	const decoratedOnClick = useAccordionButton(eventKey, () => {});
	const isCurrentEventKey = activeEventKey === eventKey;

	return (
		<button
			type='button'
			className={isCurrentEventKey ? 'open' : ''}
			style={{ backgroundColor: 'transparent' }}
			onClick={decoratedOnClick}
		>
			{children}{' '}
			<span className='off'>
				<Plus />
			</span>
			<span className='on'>
				<Dash />
			</span>
		</button>
	);
}
const DislayMultiple = ({ label, value, key, node }) => {
	// console.log({ label, value });
	// console.log(value);

	if (node.length === 0)
		return (
			<div className='md-ln' key={`${key}-cont`}>
				<div className='md-lbl' key={`${key}-lbl`}>
					{label}:{' '}
				</div>
				<div className='md-cnt' key={`${key}-value`}>
					{value}
				</div>
			</div>
		);
	else {
		return (
			<div className='md-ln' key={`${key}-cont`}>
				<div className='md-lbl' key={`${key}-lbl`}>
					{label}:{' '}
				</div>
				<div className='md-cnt' key={`${key}-value`}>
					{Array.from(node).map((item, index) => {
						return (
							<div
								key={`${key}-value-${index}`}
								style={{
									display: index === 0 ? 'inline' : 'block',
								}}
								dangerouslySetInnerHTML={{
									__html: item.outerHTML,
								}}
							/>
						);
					})}
				</div>
			</div>
		);
	}
};

const DisplayMetadata = ({ metadata, title = true, xmlDoc }) => {
	//console.log(metadata);
	//console.log(xmlDoc);
	return ISADG_METADATA?.map(
		(meta_item, indx) =>
			xmlDoc
				?.querySelector(`metadata > ${meta_item?.field}`)
				?.hasChildNodes() && (
				<div
					className='md-info'
					key={`${meta_item.field}-${indx}-${meta_item.label}`}
				>
					{title && <div className='md-area'>{meta_item.label}</div>}
					{meta_item.children.map((item, index) => {
						return (
							xmlDoc
								?.querySelector(
									`metadata > ${meta_item.field} > ${item.field}`
								)
								?.hasChildNodes() &&
							DislayMultiple({
								label: item.label,
								value: xmlDoc.querySelector(
									`metadata > ${meta_item.field} > ${item.field}`
								).textContent,
								node: xmlDoc.querySelector(
									`metadata > ${meta_item.field} > ${item.field}`
								).children,
								key: `${item.field}-${index}}`,
							})
						);
					})}
				</div>
			)
	);
};

export default function ISADgCollectionTree({
	isadg,
	selected,
	hasHierarchyTree,
	collection = false,
	showMetadata,
	itemInfo,
	inventory = null,
}) {
	//console.log(collection, showMetadata, itemInfo);
	const [showTreeView, setShowTreeView] = useState(false);
	let parser = new DOMParser();
	let xmlDoc = parser.parseFromString(
		itemInfo.payload?.metadata,
		'application/xml'
	);

	return (
		<>
			{(hasHierarchyTree || showMetadata.show) && (
				<Col
					lg={3}
					className='c-tree-col d-none d-lg-block c-tree-view'
				>
					{collection && showMetadata.show && (
						<Accordion defaultActiveKey='0' className='g-md-vw'>
							{itemInfo?.payload?.ancestors &&
								renderAncestorTab(
									itemInfo?.payload.ancestors,
									3
								)}
							{itemInfo.isLoading ? (
								<div>Cargando...</div>
							) : (
								<Card>
									<Card.Header className='g-md-ia'>
										<CustomToggle eventKey='0'>
											{xmlDoc.querySelector(
												'metadata > identificacion > nivel_descripcion'
											)?.textContent ??
												'UNIDAD DOCUMENTAL SIMPLE'}
										</CustomToggle>
									</Card.Header>
									<Accordion.Collapse eventKey='0'>
										<Card.Body>
											{DisplayMetadata({
												metadata:
													itemInfo?.payload?.metadata,
												title:
													xmlDoc
														?.querySelector(
															'metadata > identificacion > nivel_descripcion'
														)
														?.textContent?.toLowerCase() !==
													'unidad documental simple',
												xmlDoc,
											})}
										</Card.Body>
									</Accordion.Collapse>
								</Card>
							)}
							{hasHierarchyTree && (
								<Card>
									<Card.Header className='g-md-ia'>
										<CustomToggle eventKey='1'>
											ESQUEMA DE CLASIFICACIÓN
										</CustomToggle>
									</Card.Header>
									<Accordion.Collapse eventKey='1'>
										<Card.Body>
											<TreeView
												isadg={isadg}
												selected={selected}
											/>
										</Card.Body>
									</Accordion.Collapse>
								</Card>
							)}
							{/* TODO: Revisar el pedir el inventario del back */}
							{inventory?.payload?.file_id && (
								<Card>
									<Card.Header className='g-md-ia'>
										<button
											type='button'
											style={{
												backgroundColor: 'transparent',
											}}
											onClick={() =>
												window.open(
													`${DRUPAL_URL}${inventory.payload.file_id}`,
													'_blank'
												)
											}
										>
											Inventario
										</button>
									</Card.Header>
								</Card>
							)}
						</Accordion>
					)}
					{(!collection || !showMetadata.show) && (
						<TreeView isadg={isadg} selected={selected} />
					)}
				</Col>
			)}
			<div
				className='d-inline-flex d-lg-none position-absolute top-0 flex-row justify-content-start align-items-start'
				style={{ left: '-10px' }}
			>
				<Button
					variant={'light'}
					className='c-tree-button shadow bg-body rounded-circle d-flex justify-content-center align-items-center'
					style={{
						width: '40px',
						aspectRatio: '1/1',
					}}
					onClick={() => setShowTreeView(!showTreeView)}
				>
					<Diagram3Fill />
				</Button>
				{showTreeView && (
					<div
						className='d-inline-block shadow-lg p-3 mb-5 bg-body rounded c-tree-view'
						style={{ zIndex: '2000' }}
					>
						<TreeView isadg={isadg} selected={selected} isFather />
					</div>
				)}
			</div>
		</>
	);
}
